import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const wishlistPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.wishlist(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/wishlist"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
